import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import LiveHeader from 'live/components/header/ui/main/main'

const App = ({ children, className }) => {
    const [top, setTop] = useState(0)

    useEffect(() => {
        setTop(document.querySelector('nav').getBoundingClientRect().height)
    }, [document.querySelector('nav')])

    return (
        <AppStyles className={className}>
            <LiveHeader />
            <div className={'inner-app'} style={{ top }}>
                {children}
            </div>
        </AppStyles>
    )
}
const AppStyles = styled.div`
    position: relative;
    height: 100%;

    .inner-app {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
`

export default App
